/**
 * 260810 E3-P2 — Trạng thái phụ đề của một tập, dưới góc nhìn "tập này có phát hành được không".
 *
 * Backend (Epic 3 Phase 1) giữ lại tập thiếu phụ đề **trong im lặng**: nó nằm mãi ở `scheduled` mà
 * không có thông báo nào, vì lúc đó không có ai đang nhìn màn hình để báo. Nếu giao diện cũng im nốt
 * thì đội content sẽ tưởng hệ thống hỏng. Hàm này là phần "nói cho người dùng biết".
 *
 * Tách khỏi file có `import 'antd'` để test được — xem `subtitleJobView.ts`.
 */

/** Ngôn ngữ bắt buộc trước khi phát hành — phải khớp `REQUIRED_SUBTITLE_LANGUAGE` bên backend. */
export const REQUIRED_LANGUAGE = 'en';

/** Chỉ những trạng thái đang trên đường phát hành mới đáng cảnh báo. */
const PENDING_PUBLISH_STATUSES = ['ready', 'scheduled'];

export interface SubtitleState {
    /** Các ngôn ngữ thực sự có file (url không rỗng). */
    languages: string[];
    /** Tập đang chờ phát hành nhưng thiếu phụ đề bắt buộc ⇒ backend sẽ giữ lại. */
    blocking: boolean;
    /** Câu giải thích hiển thị cho admin (rỗng khi không có gì đáng nói). */
    hint: string;
}

function isPlainObject(v: unknown): v is Record<string, unknown> {
    return typeof v === 'object' && v !== null && !Array.isArray(v);
}

export function describeSubtitleState(subtitles: unknown, status: string): SubtitleState {
    const languages: string[] = [];
    if (isPlainObject(subtitles)) {
        for (const [lang, info] of Object.entries(subtitles)) {
            if (!isPlainObject(info)) continue;
            const url = info.url;
            if (typeof url === 'string' && url.trim()) languages.push(lang);
        }
    }

    const missingRequired = !languages.includes(REQUIRED_LANGUAGE);
    const blocking = missingRequired && PENDING_PUBLISH_STATUSES.includes(status);

    return {
        languages,
        blocking,
        hint: blocking
            ? 'Tập chưa có phụ đề tiếng Anh nên chưa thể phát hành — hệ thống sẽ giữ lại cho tới khi có.'
            : '',
    };
}
